import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { ConnectionsComponent } from '../connections/connections.component';
import { ClassificationComponent } from '../classification/classification.component';

const routes: Routes = [
  { path: '', component: LayoutComponent, children: [
    // { path: 'classification', component: ClassificationComponent },
    { path: '', loadChildren: 'app/dashboard/dashboard.module#DashboardModule' },
    { path: 'classification', loadChildren: 'app/classification/classification.module#ClassificationModule' },
    { path: 'connections', loadChildren: 'app/connections/connections.module#ConnectionsModule' },
    { path: 'classificationCategories', loadChildren: 'app/classification-categories/classification-categories.module#ClassificationCategoriesModule' },
    { path: 'classificationReport', loadChildren: 'app/classify-report/classify-report.module#ClassifyReportModule' },
    { path: 'masterMappings', loadChildren: 'app/master-mappings/master-mappings.module#MasterMappingsModule' },
    { path: 'masterMappingsReport', loadChildren: 'app/master-mappings-report/master-mappings-report.module#MasterMappingsReportModule' },
    { path: 'classificationSearchReport', loadChildren: 'app/classification-search-report/classification-search-report.module#ClassificationSearchReportModule' },
    { path: 'transform', loadChildren: 'app/transform/transform.module#TransformModule' },
    { path: 'anonymisation', loadChildren: 'app/anonymisation/anonymisation.module#AnonymisationModule' },
    { path: 'deletionApprovals', loadChildren: 'app/deletion-approvals/deletion-approvals.module#DeletionApprovalsModule' },
    { path: 'dataRetentionPolicies', loadChildren: 'app/data-retention-policies/data-retention-policies.module#DataRetentionPoliciesModule' },
    { path: 'search', loadChildren: 'app/search/search.module#SearchModule' }
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
